// extracted by mini-css-extract-plugin
module.exports = {"ant-form-item":"general_ant-form-item_1hOLD"};